import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { useFetch } from '@/modules/core/composables/useFetch'

export interface BillingInvoice {
  id: number
  stripe_invoice_id: string
  billable_id: number
  billable_type: string
}

export const useInvoiceStore = defineStore('billing/invoiceStore', () => {
  const items = ref<BillingInvoice[]>([])
  const invoices = computed(() => items.value)

  const fetchInvoices = async ({
    slug,
    billable_id,
    billable_type,
  }: {
    slug: string
    billable_id: string
    billable_type: string
  }) => {
    const data = await useFetch(
      `/v4/${slug}/billing/invoices?billable_id=${billable_id}&billable_type=${billable_type}`,
    ).get<BillingInvoice[]>()
    items.value = data
  }

  /**
   * Pay invoices for a billable entity.
   * Backend determines whether to use subscription or billing invoice payment.
   */
  const pay = async ({
    slug,
    billable_id,
    billable_type,
  }: {
    slug: string
    billable_id: string
    billable_type: string
  }): Promise<void> => {
    await useFetch(`/v4/${slug}/billing/pay`).post({
      billable_id,
      billable_type,
    })
  }

  return {
    items,
    invoices,
    fetchInvoices,
    pay,
  }
})
